import { render, staticRenderFns } from "./MarketingCreditsListItem.vue?vue&type=template&id=14487d32&scoped=true"
import script from "./MarketingCreditsListItem.vue?vue&type=script&lang=js"
export * from "./MarketingCreditsListItem.vue?vue&type=script&lang=js"
import style0 from "./MarketingCreditsListItem.vue?vue&type=style&index=0&id=14487d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14487d32",
  null
  
)

export default component.exports